import styled from 'styled-components';

export const CustomAudienceProfilesStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-24);

  .customAudienceProfiles {
    &__description {
      border-bottom: 1px solid var(--color-sonata-primary-500);
      color: var(--color-sonata-primary-500);
      font: var(--font-info-600-medium);
      margin: 0;
      padding-bottom: var(--spacing-8);
    }

    &__cards {
      display: flex;
      gap: var(--spacing-16);
    }

    &__card {
      align-items: stretch;
      background-color: var(--color-sonata-primary-200);
      border: 1px solid transparent;
      border-radius: 4px;
      color: var(--color-sonata-primary-500);
      cursor: pointer;
      display: flex;
      flex: 1 1 0;
      flex-direction: column;
      gap: var(--spacing-8);
      min-width: 0;
      padding: var(--spacing-10) var(--spacing-10) var(--spacing-16);
      text-align: center;

      &:hover {
        border-color: var(--color-sonata-primary-400);
      }

      &--selected,
      &--selected:hover {
        background-color: var(--color-sonata-interaction-200);
        border-color: var(--color-sonata-interaction-500);
        color: var(--color-sonata-interaction-500);
      }
    }

    &__cardImage {
      align-items: center;
      background-color: var(--color-sonata-primary-300);
      border-radius: 8px;
      color: var(--color-sonata-primary-500);
      display: flex;
      height: 88px;
      justify-content: center;
    }

    &__cardIcon {
      font-size: 40px;
      --fa-primary-color: currentColor;
      --fa-secondary-color: currentColor;
    }

    &__card--selected &__cardImage {
      background-color: var(--color-sonata-interaction-300);
      color: var(--color-sonata-secondary-white);
    }

    &__cardTitle {
      font: var(--font-body-400-bold);
    }

    &__cardDescription {
      font: var(--font-info-600-regular);
    }
  }
`;
